import { useContext } from 'react';
import { Context as PurchaseTypeContext } from '@context/PurchaseTypeContext';

const useCheckoutStartedEvtProps = (goalDetails = {}) => {
  const purchaseType = useContext(PurchaseTypeContext);
  const { uid, name } = goalDetails;
  return {
    purchase_type: purchaseType,
    goal_uid: uid,
    goal_name: name,
    is_subscription_active: false,
    is_upgrade: false
  };
};

export default useCheckoutStartedEvtProps;
